import QtdModulo from '../../ModulosCrefito/QtdModulo'
import TOpublicidadeRedeSocial from '../../ModulosCrefito/ModulosTO/TOpublicidadeRedeSocial'
import TOpublicidade from '../../ModulosCrefito/ModulosTO/TOpublicidade'
import TOoutrosDados from '../../ModulosCrefito/ModulosTO/TOoutrosDados'
import TOorientacoes from '../../ModulosCrefito/ModulosTO/TOorientacoes'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const RedeSocial = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="REDE SOCIAL - PERFIL SOCIAL" modulo="toidprofissional" />
            <TOpublicidadeRedeSocial modulo="toidprofissional" />
            <QtdModulo texto="PUBLICIDADE" modulo="topublicidade" />
            <TOpublicidade modulo="topublicidade" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="tooutrosDados" />
            <TOoutrosDados modulo="tooutrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/RECOMENDAÇÕES/NOTIFICAÇÕES" modulo="toorientacoes" />
            <TOorientacoes modulo="toorientacoes" />
        </>
    )
}

export default RedeSocial